import { render } from "./ArchivedOpportunityStandardSearch.vue?vue&type=template&id=c08ac668"
import script from "./ArchivedOpportunityStandardSearch.vue?vue&type=script&lang=js"
export * from "./ArchivedOpportunityStandardSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__